import { render, staticRenderFns } from "./OfferSetupReviewEmailSummary.vue?vue&type=template&id=427e31fa&scoped=true&lang=pug&"
import script from "./OfferSetupReviewEmailSummary.vue?vue&type=script&lang=js&"
export * from "./OfferSetupReviewEmailSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427e31fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VDivider,VSimpleTable,VSpacer})
